<template>
    <div>
        <div class="sov-data"
             :class="[{'no-value': !val, 'loading': loading, 'with-actual-value': showActualValue}, `font-${font}`]"
             :style="backgroundStyle">
            <div :style="sovStyle" class="sov-data-animation" :class="{'no-animation': !percent}">
                <span class="sov-value-wrap">
                    <span v-if="!loading" class="sov-value">
                        {{ percent }}
                        <span v-if="showActualValue" class="font-9 actual-value">
                            {{ actualValue | decimalFormat }}
                        </span>
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>

import decimalFormat from 'services/filters/decimalFormat';

const hexToRgb = (hex) => {
    if (!hex) return { };
    const result = hex.match(/[^#]{1,2}/g);
    return result ? {
        r: parseInt(result[0], 16),
        g: parseInt(result[1], 16),
        b: parseInt(result[2], 16)
    } : { };
};

export default {
    name: 'PercentBar',
    filters: {
        decimalFormat
    },
    props: {
        val: Number,
        maxVal: Number,
        actualValue: Number,
        showActualValue: {
            type: Boolean,
            default: false
        },
        emptySpaceColor: {
            type: String,
            default: 'transparent'
        },
        filledSpaceColor: {
            type: String
        },
        fillColorAlpha: {
            type: Number,
            default: 1
        },
        font: {
            type: Number,
            default: 7
        },
        noValueText: String,
        loading: Boolean,
        borderRadius: {
            type: Number,
            default: 0
        }
    },
    computed: {
        width() {
            return (this.val / this.maxVal) * 100;
        },
        backgroundStyle() {
            return { 'background-color': this.emptySpaceColor, 'border-radius': `${this.borderRadius}px` };
        },
        sovStyle() {
            // rgba color is $primary-500 with 10% opacity
            const fillColor = hexToRgb(this.filledSpaceColor);
            const fillColorRGB = `rgba(${fillColor.r}, ${fillColor.g}, ${fillColor.b}, ${this.fillColorAlpha})`;
            let backgroundColor;
            let width;
            if (!this.width) {
                backgroundColor = 'transparent';
                width = '0';
            } else {
                backgroundColor = fillColorRGB;
                width = `${Math.round(this.width)}%`;
            }

            const borderRadius = `${this.borderRadius}px`;
            return this.loading ? {} : {
                'background-color': backgroundColor,
                width,
                'border-top-left-radius': borderRadius,
                'border-bottom-left-radius': borderRadius,
                'border-top-right-radius': width === '100%' ? borderRadius : 0,
                'border-bottom-right-radius': width === '100%' ? borderRadius : 0
            };
        },
        percent() {
            return ((this.showActualValue && this.actualValue) || this.val) ? `${this.val}%` : this.noValueText;
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide";

@keyframes skeletonLoader {
    0% {
        background: $light-200;
    }
    100% {
        background: $light-500;
    }
}

.sov-data {
    color: $dark-300;
    position: relative;

    &.with-actual-value {
        color: $chart-text;
    }

    .actual-value {
        font-weight: normal;
        margin-left: 5px;
    }
    &.no-value {
        color: $light-800;
    }
    &.loading {
        animation: skeletonLoader 1.5s alternate infinite linear;
        background-color: $light-200;
    }
}

.sov-data-animation {
    transition: width 1.4s ease-in;
    width: 0;
    &.no-animation {
        transition: none;
    }
}

.sov-value-wrap {
    margin-left: 10px;
    margin-right: 3px;
}
.sov-value {
    position: absolute;
}
</style>
